<template>
  <fragment>
    <div class="main_page">
      <app-navbar></app-navbar>
      <div class="page">
        <loading :active.sync="isPageLoading" is-full-page></loading>
        <div v-if="!isPageLoading">
          <div class="page-title">
            <h1>Participant Types</h1>
          </div>
          <div class="page-content">
            <form>
              <div class="form-group row">
                <label for="searchKeyword" class="col-sm-2 col-form-label">Search by Keyword</label>
                <div class="col-sm-8">
                  <input type="text" class="form-control" v-model="searchKeyword" />
                </div>
                <div class="col-sm-2">
                  <button type="button" class="btn btn-primary" @click="newParticipantType">
                    <i class="fas fa-plus-circle"></i> Add New
                  </button>
                </div>
              </div>
            </form>
            <ul class="list-group list-group-flush border-bottom">
              <li class="list-group-item d-flex px-2" v-for="participantType in searchLocalDataset(getParticipantTypes)" :key="participantType.id">
                <div class="mr-auto">
                  <p class="m-0">{{ participantType.name }}</p>
                </div>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column"
                    title="Edit" @click.prevent="editParticipantType(participantType.id)">
                  <img class="mb-1" src="@/assets/document.svg" alt />
                  <span class="small-grey">Edit</span>
                </a>
                <a role="button" href="#" class="d-flex justify-content-between align-items-center flex-column ml-3"
                    title="Delete" @click.prevent="deleteParticipantType(participantType.id)">
                  <img class="mb-1" src="@/assets/red_x.svg" alt />
                  <span class="small-grey">Delete</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="bv-modal-participant-type" size="lg" hide-header hide-footer :no-close-on-backdrop="true">
      <participant-type></participant-type>
    </b-modal>
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MessageBox from "@/utils/messagebox";
import Toast from "@/utils/toast";

export default {
  name: "configuration-participant-types",
  components: {
    'app-navbar': () => import('@/components/app-navbar.vue'),
    'participant-type': () => import('@/views/configuration/components/participant-type.vue')
  },
  data: function() {
    return {
      isPageLoading: true,
      searchKeyword: null
    };
  },
  computed: {
    ...mapGetters(["getParticipantTypes"])
  },
  methods: {
    newParticipantType() {
      this.resetParticipantType().then(() => {
        this.$bvModal.show("bv-modal-participant-type");
      });
    },
    editParticipantType(id) {
      this.fetchParticipantType(id).then(() => {
        this.$bvModal.show("bv-modal-participant-type");
      });
    },
    async deleteParticipantType(id) {
      let confirm = await MessageBox.confirm(this, "Remove Participant Type", "Are you sure you want to remove participant type?");

      if (confirm) {
        this.removeParticipantType(id).then(() => {
          Toast.success(this, "Successfully removed participant type!");
        });
      }
    },
    searchLocalDataset(values) {
      if (!this.searchKeyword || this.searchKeyword === "") return values;

      return values.filter(i => i.name.includes(this.searchKeyword));
    },
    ...mapActions([ "fetchParticipantType", "fetchParticipantTypes", "removeParticipantType", "resetParticipantType" ])
  },
  created: function() {
    this.fetchParticipantTypes().then(() => {
      this.isPageLoading = false;
    });
  }
};
</script>
